// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1bsET","image":"App_image__3-h6R"};